import { AccountData } from "../sf-page-header/api/salesforceApiClient";

export const parseJsonSafe = <T>(
    jsonString: string | undefined
): T | undefined => {
    if (!jsonString) {
        return undefined;
    }
    try {
        return JSON.parse(jsonString.replace(/'/g, '"')) as T;
    } catch {
        return undefined;
    }
};

export const getAccountSwitchRedirectUrl = (
    account: AccountData,
    issuer?: string | undefined
): string => {
    if (typeof window !== "undefined") {
        const baseUrl = issuer
            ? new URL(issuer).origin
            : "https://account-s.trumpf.com";
        return `${baseUrl}/account-switch?accountId=${encodeURIComponent(account.Id)}&redirectUrl=${encodeURIComponent(window.top.location.href)}`;
    }
    return "";
};

export const getAccountAddRedirectUrl = (
    issuer?: string | undefined
): string => {
    if (typeof window !== "undefined") {
        const baseUrl = issuer
            ? new URL(issuer).origin
            : "https://account-s.trumpf.com";
        return `${baseUrl}/account-data?action=addAccount`;
    }
    return "";
};
